module.exports = __webpack_public_path__ + "static/logo-5cba72598ec7f8430efc9c95be891479.png";